import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
      topbar: {
          show: false
      },
      leftSidebar: {
          show: false,
          mode: "close"
      }
  },
  layout2Settings: {
      mode: "full",
      topbar: {
          show: false
      },
      navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const AllReport = MatxLoadable({
  loader: () => import("./AllReport")
})

const AllReportRoutes = [
  {
    path: "/all_report",
    component: AllReport,
    auth: authRoles.admin
  }
];

export default AllReportRoutes;